import React from 'react';
import { PageContent, LandingPageProvider } from '@ruggable/ecomm-design-guide';
import siteConfig from '../utils/configs/site-config';
import { mountReact } from '../../react/utils/mountReact';

import '../../styles/tools/shame.scss';
import '@ruggable/ecomm-design-guide/dist/cjs/index.css';

const DesignGuidePage404 = () => {
  const defaultCurrency = window.ruggableStorefrontProps.shop.currency;
  const defaultLocale = window.ruggableStorefrontProps.defaultLocale;
  const handle = '404';
  return (
    <LandingPageProvider defaultCurrency={defaultCurrency} defaultLocale={defaultLocale} config={siteConfig}>
      <PageContent contentType='page' handle={handle} defaultLocale={defaultLocale} />
    </LandingPageProvider>
  );
};

mountReact('#contentful-page-renderer', DesignGuidePage404);
